import { render } from "./RelacionOpcionPerfilRegistro.vue?vue&type=template&id=13c34b00"
import script from "./RelacionOpcionPerfilRegistro.vue?vue&type=script&lang=js"
export * from "./RelacionOpcionPerfilRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__